import { Link } from 'react-router-dom';
import { ScrollSection } from '../components/ScrollSection';

function Diagnostic() {
  return (
    <>
      <div
        className="container-fluid page-header wow fadeIn"
        data-wow-delay="0.1s"
        style={{
          background: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url(/img/xxray.jpeg)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="container text-center py-5 mt-4">
          <h1 className="display-2 text-white fw-bold mb-3 animated slideInDown">Diagnostic Services</h1>
          <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb justify-content-center mb-0">
              <li className="breadcrumb-item fw-bold">
                <Link to="/" className="text-white">
                  Home
                </Link>
              </li>
              <li className="breadcrumb-item fw-bold text-white" aria-current="page">
                Diagnostic Services
              </li>
            </ol>
          </nav>
        </div>
      </div>

      <ScrollSection>
        <div className="container py-5">
          <div className="row">
            <div className="col-lg-12">
              <h2 className="mb-4">Diagnostic Services</h2>
              <p>
                Our Diagnostic Services utilize state-of-the-art equipment and technology to provide accurate and timely
                diagnostic results. We offer a comprehensive range of diagnostic tests and imaging services to support
                effective treatment planning.
              </p>
            </div>
          </div>
        </div>
      </ScrollSection>
    </>
  );
}

export default Diagnostic;
